export default "__VITE_ASSET__DqN6M3DN__"